import {useEffect, useState} from "react";
import MoonLoader from "react-spinners/MoonLoader";
import {getLoadingSnapshot, subscribeLoading} from "../service/loading-indicator";
import "../style/loading-indicator.css";

/**
 * Eski `#request-spinner` div'inin yerini alır. Fark: gösterge artık her istekte değil,
 * yalnız uzayan isteklerde ve çoğu durumda ekranı bloklamadan (üst çubuk) görünür.
 * Kurallar loading-indicator.js'te; burası sadece o durumu çizer.
 */
export default function LoadingIndicator() {
    const [state, setState] = useState(getLoadingSnapshot);

    useEffect(() => {
        // Abone olurken anlık durumu bir kez daha al: abonelikten önce başlamış bir istek kaçmasın.
        setState(getLoadingSnapshot());
        return subscribeLoading(setState);
    }, []);

    return (
        <>
            {state.bar && (
                <div className={'app-progress-bar'} role={'presentation'}>
                    <div className={'app-progress-bar__fill'}/>
                </div>
            )}
            {state.shield && (
                <div className={`app-blocking-shield${state.dim ? ' app-blocking-shield--dim' : ''}`}>
                    {state.dim && (
                        <div className={'app-blocking-shield__spinner'}>
                            <MoonLoader color={'#E0982A'} size={56}/>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}
